import PropTypes from 'prop-types'
import { useState } from 'react'

import { ModalUpload } from './ModalUpload'
import styles from './Upload.module.css'

export const Upload = ({ idDoc, idPerfil, idTipo, onCarga }) => {
  const [showModal, setShowModal] = useState(false)
  const handleToggle = () => setShowModal((prev) => !prev)
  return (
    <>
      <button type="button" className={styles.uploadBtn} onClick={handleToggle}>
        <i className="bi bi-upload" />
        <span>Subir archivo</span>
      </button>
      <ModalUpload
        show={showModal}
        onClose={handleToggle}
        idDoc={idDoc}
        idPerfil={idPerfil}
        idTipo={idTipo}
        onCarga={onCarga}
      />
    </>
  )
}

Upload.propTypes = {
  idDoc: PropTypes.number,
  idPerfil: PropTypes.number,
  idTipo: PropTypes.string,
  onCarga: PropTypes.func
}
